import { ESharingState } from "app/components/sharingAssetModal/types";

export const commonKeys = {
    sharingStateContainer: {
        [ESharingState.PRIVATE]: {
            title: "sharing.asset.modal.options.private.title",
        },
        [ESharingState.ACCOUNT]: {
            title: "sharing.asset.modal.options.account.title",
        },
        [ESharingState.SUBSET_OF_USERS]: {
            title: "sharing.asset.modal.options.users.title",
        },
    },
};
